import React from 'react'
import {
  Header,
  Table,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import ScreenContainer from './ScreenContainer.js'
import Tier from './Tier.js'
import OptionalSelectTableHeaderCell from './OptionalSelectTableHeaderCell.js'
import OptionalItemCounterCell from './OptionalItemCounterCell.js'
import OptionalCompareTableHeaderCells from './OptionalCompareTableHeaderCells.js'
import OptionalCompareItemCells from './OptionalCompareItemCells.js'
import { areas } from './curriculum.js'

function buildTable(mode, selection, selections, comparisonMode, comparisonSelectionNames) {
  let result = [];
  for (const area of areas) {
    result.push(
      <Table.Row warning key={area.id}>
        <Table.Cell collapsing>{area.id}</Table.Cell>
        <Table.Cell><Link to={"/area/"+area.id}><b>{area.name}</b></Link></Table.Cell>
        <Table.Cell collapsing textAlign="right">{area.core1}</Table.Cell>
        <Table.Cell collapsing textAlign="right">{area.core2}</Table.Cell>
        <Table.Cell collapsing textAlign="right">{area.elective?"Y":""}</Table.Cell>
        <OptionalItemCounterCell mode={mode} selection={selection} fqidPrefix={area.id}/>
        <OptionalCompareItemCells mode={mode} selections={selections} comparisonMode={comparisonMode} comparisonSelectionNames={comparisonSelectionNames} fqidPrefix={area.id}/>
      </Table.Row>
    );
    for (const unit of area.units) {
      result.push(
        <Table.Row key={unit.fqid}>
          <Table.Cell collapsing disabled>{unit.fqid}</Table.Cell>
          <Table.Cell><Link to={"/unit/"+unit.fqid}>{unit.name}</Link></Table.Cell>
          <Table.Cell collapsing textAlign="right">{unit.core1}</Table.Cell>
          <Table.Cell collapsing textAlign="right">{unit.core2}</Table.Cell>
          <Table.Cell collapsing textAlign="right">{unit.electives?"Y":""}</Table.Cell>
          <OptionalItemCounterCell mode={mode} selection={selection} fqidPrefix={unit.fqid}/>
          <OptionalCompareItemCells mode={mode} selections={selections} comparisonMode={comparisonMode} comparisonSelectionNames={comparisonSelectionNames} fqidPrefix={unit.fqid}/>
        </Table.Row>
      );
    }
  }
  //console.log(result);
  return result;
}

const Units = ({mode, selection, selections, comparisonMode, comparisonSelectionNames}) => (
  <ScreenContainer mode={mode}>
    <Header as='h1'>Knowledge Units by Area</Header>
    <Table compact='very' basic='very' selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell collapsing>
          </Table.HeaderCell>
          <Table.HeaderCell>
            Name
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign='right'>
            Core-Tier1 <Tier tier='core1'/>
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign='right'>
            Core-Tier2 <Tier tier='core2'/>
          </Table.HeaderCell>
          <Table.HeaderCell collapsing textAlign='right'>
            Elective <Tier tier='elective'/>
          </Table.HeaderCell>
          <OptionalSelectTableHeaderCell mode={mode} selection={selection}/>
          <OptionalCompareTableHeaderCells
            mode={mode}
            selections={selections}
            comparisonMode={comparisonMode}
            comparisonSelectionNames={comparisonSelectionNames}
          />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          buildTable(mode, selection, selections, comparisonMode, comparisonSelectionNames)
        }
      </Table.Body>
    </Table>
  </ScreenContainer>
)

export default Units